module.exports = __webpack_public_path__ + "static/media/warning.b23444d7.png";